import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-df263fea")

_pushScopeId("data-v-df263fea")
const _hoisted_1 = { class: "admin" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_admin_head = _resolveComponent("admin-head")
  const _component_el_header = _resolveComponent("el-header")
  const _component_admin_nav = _resolveComponent("admin-nav")
  const _component_el_aside = _resolveComponent("el-aside")
  const _component_router_view = _resolveComponent("router-view")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withId(() => [
        _createVNode(_component_el_header, { height: "70px" }, {
          default: _withId(() => [
            _createVNode(_component_admin_head)
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withId(() => [
            _createVNode(_component_el_aside, { width: "250px" }, {
              default: _withId(() => [
                _createVNode(_component_admin_nav)
              ]),
              _: 1
            }),
            _createVNode(_component_el_container, null, {
              default: _withId(() => [
                _createVNode(_component_el_main, null, {
                  default: _withId(() => [
                    _createVNode(_component_router_view, null, {
                      default: _withId(({ Component }) => [
                        (_openBlock(), _createBlock(_KeepAlive, null, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                        ], 1024))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})